import api from '../../../../../api/client';
import { ENROLLMENT_REFUND } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';

export async function getRefunds(params = {}) {
  try {
    const response = await api.get(ENROLLMENT_REFUND.INDEX, {
      params,
    });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
export async function refundAction(payload = {}) {
  try {
    const response = await api.post(ENROLLMENT_REFUND.ACTION, payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
